import { FieldPresenterModel } from '../../models';
import { DataTypeEnum } from '../../models/enums/data-type.enum';
import {
  GROUP_ENTITY_ID,
  USER_ENTITY_ID,
  USERS_GROUP_ENTITY_ID,
} from '../entity-consts';

const entityCreator: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'creationInfo.doneBy',
  normalizedName: 'creationInfo.doneBy',
  _normalizedName: 'creationInfo.doneBy',
  name: {
    en: 'Created by',
    ar: 'الإنشاء بواسطة',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USER_ENTITY_ID,
  sources: [
    {
      entity: USER_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entityCreatedDate: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'creationInfo.doneAt',
  normalizedName: 'creationInfo.doneAt',
  _normalizedName: 'creationInfo.doneAt',
  name: {
    en: 'Created at',
    ar: 'تاريخ الإنشاء',
  },
  description: null,
  dataType: DataTypeEnum.Date,
  renderOptions: {
    editComponent: {
      component: 'DateTimeComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewDateTimeComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entityEditDate: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'updateInfo.doneAt',
  normalizedName: 'updateInfo.doneAt',
  _normalizedName: 'updateInfo.doneAt',
  name: {
    en: 'Updated at',
    ar: 'تاريخ التعديل',
  },
  description: null,
  dataType: DataTypeEnum.Date,
  renderOptions: {
    editComponent: {
      component: 'DateTimeComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewDateTimeComponent',
      options: {},
    },
  },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

const entityEditor: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'updateInfo.doneBy',
  normalizedName: 'updateInfo.doneBy',
  _normalizedName: 'updateInfo.doneBy',
  name: {
    en: 'Updated by',
    ar: 'التحديث بواسطة',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USER_ENTITY_ID,
  sources: [
    {
      entity: USER_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

export const ENTITY_ORDER_FIELD: FieldPresenterModel = {
  specificationVersion: 1,
  id: '_metaOrder.value',
  normalizedName: '_metaOrder.value',
  _normalizedName: '_metaOrder.value',
  name: {
    en: 'Order',
    ar: 'الترتيب',
  },
  description: null,
  dataType: DataTypeEnum.Number,
  // renderOptions: {
  //   editComponent: {
  //     component: 'DateTimeComponent',
  //     options: {},
  //   },
  //   viewComponent: {
  //     component: 'ViewDateTimeComponent',
  //     options: {},
  //   },
  // },
  source: null,
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: false,
    showAsTab: false,
    showAsTitle: false,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    isAdvancedDefaultValue: false,
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;
export const ENTITY_META_FIELDS: FieldPresenterModel[] = [
  entityCreator,
  entityCreatedDate,
  entityEditor,
  entityEditDate,
];

export const USER_FIELD: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'user',
  normalizedName: 'user',
  _normalizedName: 'user',
  name: {
    en: 'User',
    ar: 'المستخدم',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USER_ENTITY_ID,
  sources: [
    {
      entity: USER_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: true,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    showAsCategory: false,
    showAsRelationField: false,
    showAsMainPhone: false,
    showAsSubCategory: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    autoIncrementOptions: null,
    hidden: { enabled: false, expression: null },
    readonly: false,
    searchable: true,
    queryable: true,
    autoSelectFirstValue: false,
    displayOnly: {
      enabled: false,
      displaySettings: { mediaDimensions: 0, keyValueDisplay: 0 },
    },
    isAdvancedDefaultValue: false,
    repeatable: null,
    calculatedValueOptions: {
      calculationTriggers: [{ triggerOptions: null, type: 0 }],
      executionScope: 0,
      expression: '',
    },
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

export const GROUP_FIELD: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'group',
  normalizedName: 'group',
  _normalizedName: 'group',
  name: {
    en: 'Group',
    ar: 'المجموعة',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: GROUP_ENTITY_ID,
  sources: [
    {
      entity: GROUP_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: true,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    showAsCategory: false,
    showAsRelationField: false,
    showAsMainPhone: false,
    showAsSubCategory: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    autoIncrementOptions: null,
    hidden: { enabled: false, expression: null },
    readonly: false,
    searchable: true,
    queryable: true,
    autoSelectFirstValue: false,
    displayOnly: {
      enabled: false,
      displaySettings: { mediaDimensions: 0, keyValueDisplay: 0 },
    },
    isAdvancedDefaultValue: false,
    repeatable: null,
    calculatedValueOptions: {
      calculationTriggers: [{ triggerOptions: null, type: 0 }],
      executionScope: 0,
      expression: '',
    },
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
} as FieldPresenterModel;

export const USERS_GROUP_FIELD: FieldPresenterModel = {
  specificationVersion: 1,
  id: 'usersGroup',
  normalizedName: 'usersGroup',
  _normalizedName: 'usersGroup',
  name: {
    en: 'Users Group',
    ar: 'المجموعة المستخدمين',
  },
  dataType: DataTypeEnum.Entity,
  renderOptions: {
    editComponent: {
      component: 'RelationComponent',
      options: {},
    },
    viewComponent: {
      component: 'ViewRelationComponent',
      options: {},
    },
  },
  source: USERS_GROUP_ENTITY_ID,
  sources: [
    {
      entity: USERS_GROUP_ENTITY_ID,
    },
  ],
  dataCollection: null,
  validations: {
    required: {
      enabled: false,
      expression: null,
    },
    min: {
      enabled: false,
      value: null,
    },
    max: {
      enabled: false,
      value: null,
    },
  },
  options: {
    hideForEmptyValues: false,
    showInTableView: true,
    showAsTab: false,
    showAsTitle: true,
    showAsSubTitle: false,
    showAsCaption: false,
    showAsMainDate: false,
    showAsMainNumber: false,
    showAsEntryPicture: false,
    showAsCategory: false,
    showAsRelationField: false,
    showAsMainPhone: false,
    showAsSubCategory: false,
    defaultValue: null,
    columnSpan: 0,
    unique: false,
    autoIncrementOptions: null,
    hidden: { enabled: false, expression: null },
    readonly: false,
    searchable: true,
    queryable: true,
    autoSelectFirstValue: false,
    displayOnly: {
      enabled: false,
      displaySettings: { mediaDimensions: 0, keyValueDisplay: 0 },
    },
    isAdvancedDefaultValue: false,
    repeatable: null,
    calculatedValueOptions: {
      calculationTriggers: [{ triggerOptions: null, type: 0 }],
      executionScope: 0,
      expression: '',
    },
  },
  requirements: [],
  locked: {
    enabled: false,
    expression: '',
  },

  sourceOptions: {
    entriesSource: null,
  },
  validationContext: {
    invalidExpression: null,
    invalidTypeExpression: null,
  },
  block: {
    internalEntity: null,
  },
};
